import { useAuth } from "@/hooks/use-auth";
import { useDailyStatic } from "@/hooks/use-daily-static";
import { DataGrid } from "@msuite/ui/data-grid";
import { useTranslation } from "@msuite/ui/localization";
import { Tag } from "@msuite/ui/tag";
import { moment } from "@msuite/utils/date";
import { getPlanStaticStats } from "@msuite/utils/plans";
import { guardString } from "@msuite/utils/strings";
import { useMemo } from "react";

export function CommandStatistics() {
	const { plans } = useDailyStatic(moment());
	const auth = useAuth();
	const { t } = useTranslation();

	const stats = useMemo(() => {
		return getPlanStaticStats(plans, auth.organization.id);
	}, [auth.organization.id, plans]);

	/** Render */
	return (
		<div className="h-stack gap-4 items-start">
			<DataGrid
				variant="border"
				className="flex-1"
			>
				<DataGrid.Row>
					<DataGrid.Label className="capitalize">{t("planning.crews.crews")}</DataGrid.Label>
					<DataGrid.Label>{stats.crews}</DataGrid.Label>
				</DataGrid.Row>
				<DataGrid.Row>
					<DataGrid.Label>{t("dashboard.own_crews")}</DataGrid.Label>
					<DataGrid.Label>{stats.ownCrews}</DataGrid.Label>
				</DataGrid.Row>
				<DataGrid.Row>
					<DataGrid.Label>{t("dashboard.partner_crews")}</DataGrid.Label>
					<DataGrid.Label>{stats.subCrews}</DataGrid.Label>
				</DataGrid.Row>
				<DataGrid.Row>
					<DataGrid.Label>{t("projects.projects")}</DataGrid.Label>
					<DataGrid.Label>{stats.projects}</DataGrid.Label>
				</DataGrid.Row>
				<DataGrid.Row>
					<DataGrid.Label>{t("projects.tickets")}</DataGrid.Label>
					<DataGrid.Label>{stats.tickets}</DataGrid.Label>
				</DataGrid.Row>
			</DataGrid>
			<DataGrid
				variant="border"
				className="flex-1"
			>
				{plans
					.flatMap((plan) => plan.vehicleAssignmentsPlan)
					.map((vap) => (
						<DataGrid.Row key={vap.licensePlate}>
							<DataGrid.Label>
								<Tag
									color="accent"
									variant="plain"
								>
									{vap.licensePlate}
								</Tag>
							</DataGrid.Label>
							<DataGrid.Label>{guardString(vap.userName)}</DataGrid.Label>
						</DataGrid.Row>
					))}
			</DataGrid>
		</div>
	);
}
